
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6fa5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6fa5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $d411c2c8708e9195$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["9vqfN","index.81ed42d2.js","eXpas","helpers.a843ecd3.py","jXz1H","python.d333aefa.py"]'));

var $e25f9933be35cbab$exports = {};
$e25f9933be35cbab$exports = new URL("helpers.a843ecd3.py", import.meta.url).toString();


var $a54d462e358ec7ec$exports = {};
$a54d462e358ec7ec$exports = new URL("python.d333aefa.py", import.meta.url).toString();


let $3fd197433a741b8c$var$printSlow = true;
const $3fd197433a741b8c$export$5b6827adbd2671ed = (prompt)=>{
    $3fd197433a741b8c$export$d648bf4a21e2ac4(prompt);
    const input = document.getElementById("console-input");
    return new Promise((resolve)=>{
        const onEnter = (event)=>{
            if (event.key === "Enter") {
                const userInput = input.value;
                input.value = "";
                input.removeEventListener("keyup", onEnter);
                resolve(userInput);
            }
        };
        input.addEventListener("keyup", onEnter);
    });
};
let $3fd197433a741b8c$var$loading = true;
const $3fd197433a741b8c$export$d648bf4a21e2ac4 = (text, end = "\n")=>{
    if ($3fd197433a741b8c$var$loading) {
        $3fd197433a741b8c$var$loading = false;
        const loadingEl = document.getElementById("loading");
        loadingEl.style.display = "none";
        const consoleEl = document.getElementById("console");
        consoleEl.style.display = "flex";
        setTimeout(()=>{
            consoleEl.style.bottom = "50%";
        }, 1);
    }
    const output = document.getElementById("console-output");
    output.textContent += `${text}${end}`;
    // Scroll to the bottom
    output.scrollTop = output.scrollHeight;
};
const $3fd197433a741b8c$var$customPrintSlow = async (text, end = "\n")=>{
    for (const char of text){
        $3fd197433a741b8c$export$d648bf4a21e2ac4(char, "");
        if ($3fd197433a741b8c$var$printSlow) await new Promise((resolve)=>setTimeout(resolve, 10));
    }
    $3fd197433a741b8c$export$d648bf4a21e2ac4(end);
};
const $3fd197433a741b8c$var$customKulrekWait = async ()=>{
    await new Promise((resolve)=>setTimeout(resolve, 2000));
};
const $3fd197433a741b8c$var$customTextSpeedOption = (settingOption)=>{
    $3fd197433a741b8c$var$printSlow = settingOption == 0;
};
const $3fd197433a741b8c$var$customClear = ()=>{
    const output = document.getElementById("console-output");
    output.textContent = "";
};
// Add this function to the global scope so it can be called from Python
window.customInput = $3fd197433a741b8c$export$5b6827adbd2671ed;
window.customPrint = $3fd197433a741b8c$export$d648bf4a21e2ac4;
window.customPrintSlow = $3fd197433a741b8c$var$customPrintSlow;
window.customClear = $3fd197433a741b8c$var$customClear;
window.customKulrekWait = $3fd197433a741b8c$var$customKulrekWait;
window.customTextSpeedOption = $3fd197433a741b8c$var$customTextSpeedOption;


let $35da740d59af89ba$var$pyodide;
let $35da740d59af89ba$var$gameRunning = false;
window.onload = async ()=>{
    // The pyodide package is downloaded via a CDN.
    // eslint-disable-next-line no-undef
    $35da740d59af89ba$var$pyodide = await loadPyodide();
    // Load the game code
    $35da740d59af89ba$var$runGame();
};
const $35da740d59af89ba$var$runGame = async ()=>{
    if ($35da740d59af89ba$var$gameRunning) return;
    $35da740d59af89ba$var$gameRunning = true;
    const gameCodeResp = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($a54d462e358ec7ec$exports))));
    let gameCode = await gameCodeResp.text();
    // Modify the game code to work with the browser.
    gameCode = gameCode.replace(/input\(\)/g, "(await input())");
    gameCode = gameCode.replace(/def play_game\(\):/g, "async def play_game():");
    gameCode = gameCode.replace(/def print_slow\(/g, "def print_slo(");
    gameCode = gameCode.replace(/def clear\(/g, "def clea(");
    gameCode = gameCode.replace(/def kulrek_wait\(/g, "def kulrek_wai(");
    gameCode = gameCode.replace(/def txt_speed_option\(/g, "def txt_speed_optio(");
    gameCode = gameCode.replace(/print_slow\(/g, "await print_slow(");
    gameCode = gameCode.replace(/kulrek_wait\(/g, "await kulrek_wait(");
    gameCode = gameCode.replace(/def move_hint\(/g, "async def move_hin(");
    gameCode = gameCode.replace(/move_hint\(/g, "await move_hint(");
    gameCode = gameCode.replace(/def move_hin\(/g, "def move_hint(");
    gameCode = gameCode.replace(/def game_hint\(/g, "async def game_hin(");
    gameCode = gameCode.replace(/game_hint\(/g, "await game_hint(");
    gameCode = gameCode.replace(/def game_hin\(/g, "def game_hint(");
    gameCode = gameCode.replace(/def minigame_rules\(/g, "async def minigame_rul(");
    gameCode = gameCode.replace(/minigame_rules\(/g, "await minigame_rules(");
    gameCode = gameCode.replace(/def minigame_rul\(/g, "def minigame_rules(");
    gameCode = gameCode.replace(/def play_minigame\(/g, "async def play_minigam(");
    gameCode = gameCode.replace(/play_minigame\(/g, "await play_minigame(");
    gameCode = gameCode.replace(/def play_minigam\(/g, "def play_minigame(");
    gameCode = gameCode.replace(/def ending_stuffs\(/g, "async def ending_stuf(");
    gameCode = gameCode.replace(/ending_stuffs\(/g, "await ending_stuffs(");
    gameCode = gameCode.replace(/def ending_stuf\(/g, "def ending_stuffs(");
    gameCode = gameCode.replace(/def gambling_quit\(/g, "async def gambling_qui(");
    gameCode = gameCode.replace(/gambling_quit\(/g, "await gambling_quit(");
    gameCode = gameCode.replace(/def gambling_qui\(/g, "def gambling_quit(");
    const helpersResp = await fetch((0, (/*@__PURE__*/$parcel$interopDefault($e25f9933be35cbab$exports))));
    const helpersCode = await helpersResp.text();
    const pythonCode = `${helpersCode}\n${gameCode}`;
    try {
        await $35da740d59af89ba$var$pyodide.runPythonAsync(pythonCode);
    } catch (error) {
        (0, $3fd197433a741b8c$export$d648bf4a21e2ac4)(`Error: ${error}`);
    } finally{
        $35da740d59af89ba$var$gameRunning = false;
    }
};


//# sourceMappingURL=index.81ed42d2.js.map
